import { useState } from 'react';
import { faqs } from '@/mocks/home';

export default function FaqSection() {
  const [openId, setOpenId] = useState<number | null>(faqs[0]?.id ?? null);

  const toggle = (id: number) => {
    setOpenId((prev) => (prev === id ? null : id));
  };

  return (
    <section id="faq" className="w-full bg-background-100 py-16 md:py-24 scroll-mt-20">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-4">
            <p className="text-xs tracking-[0.3em] text-primary-600 font-medium mb-2">FAQ</p>
            <h2 className="font-heading font-black text-2xl md:text-4xl text-foreground-950">
              吃瓜前常见问题
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              第一次来黑吃瓜网？下面几个问题涵盖了内容范围、榜单规则和参与讨论的方式。
            </p>
            <a
              href="#subscribe"
              className="mt-6 inline-flex items-center gap-2 text-sm text-primary-600 hover:text-primary-700 transition-colors"
            >
              还有其他疑问？写信给我们
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </a>
          </div>

          <div className="lg:col-span-8">
            <dl className="space-y-3">
              {faqs.map((faq) => {
                const isOpen = openId === faq.id;
                return (
                  <div
                    key={faq.id}
                    className="bg-background-50 border border-background-200/70 rounded-lg overflow-hidden"
                  >
                    <dt>
                      <button
                        type="button"
                        onClick={() => toggle(faq.id)}
                        aria-expanded={isOpen}
                        className="w-full flex items-center justify-between gap-4 text-left px-5 md:px-6 py-5 cursor-pointer hover:bg-background-100/50 transition-colors"
                      >
                        <h3 className="font-heading font-bold text-sm md:text-base text-foreground-950">
                          {faq.question}
                        </h3>
                        <span
                          className={`shrink-0 w-8 h-8 flex items-center justify-center rounded-full transition-colors ${
                            isOpen ? 'bg-primary-500 text-background-50' : 'bg-background-100 text-foreground-600'
                          }`}
                        >
                          <i
                            className={`${isOpen ? 'ri-subtract-line' : 'ri-add-line'} text-lg`}
                            aria-hidden="true"
                          ></i>
                        </span>
                      </button>
                    </dt>
                    <dd
                      className={`px-5 md:px-6 overflow-hidden transition-all duration-300 ${
                        isOpen ? 'max-h-64 pb-6 opacity-100' : 'max-h-0 opacity-0'
                      }`}
                    >
                      <p className="text-sm text-foreground-700 leading-relaxed border-t border-background-100 pt-4">
                        {faq.answer}
                      </p>
                    </dd>
                  </div>
                );
              })}
            </dl>
          </div>
        </div>
      </div>
    </section>
  );
}